
    import './styles.scoped.css';
    export default {
  "hide-navigation": "awsui_hide-navigation_2p2ab_vo4j1_13",
  "navigation-container": "awsui_navigation-container_2p2ab_vo4j1_19",
  "navigation": "awsui_navigation_2p2ab_vo4j1_19",
  "is-navigation-open": "awsui_is-navigation-open_2p2ab_vo4j1_39",
  "is-navigation-collapsed": "awsui_is-navigation-collapsed_2p2ab_vo4j1_43",
  "expand-navigation-toggle": "awsui_expand-navigation-toggle_2p2ab_vo4j1_55"
};
  